import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { PUBLISH } = STEP_IDENTIFIER_NAME;

export const publish: StepConfig = {
	name: PUBLISH,
	isAuthenticationRequired: true,
	isEnabled: () => true,
};
